/**
 * Ties the house mark to whichever game is wearing it.
 *
 * WHY THE ACCENTS LIVE HERE AND NOT IN THE REGISTRY. In the source Next.js app
 * this reads an `accent` off `data/games.ts`, which also carries every game's
 * info-screen prose. This platform's `game-registry.ts` is a different animal —
 * it is the lazy-import table for thirty-odd games and has no visual identity in
 * it at all. Adding a colour to every entry to serve nine of them would put a
 * presentation concern in the middle of the module that decides what code gets
 * downloaded, so the ten that show the title sequence are listed here instead.
 *
 * The values are the source app's own, so the mark arrives in the same colour on
 * both sides and a future sync is a diff of one table rather than a hunt.
 */

import { DEFAULT_ACCENT } from './identity';

/**
 * The self-contained games, and the colour each one owns.
 *
 * Keyed by the platform's game id — note `aether-dynasty`, which the source app
 * still calls `matching-game`.
 */
const ACCENTS: Record<string, string> = {
  'aether-dynasty': '#a855f7',
  'car-racing': '#ff512f',
  'coin-duel': '#00e5ff',
  'collapse-factor': '#4fd2e8',
  'horse-racing': '#f7971e',
  'kamba-adeema': '#d8a63a',
  'kana-mutti': '#f0803a',
  'pixel-poker': '#3ddc78',
  'sky-crash': '#e11d48',
  'whack-a-mole': '#8ddc3c',
};

/**
 * The accent for a game id, falling back to the platform's own violet.
 *
 * The fallback is not a defensive nicety: a user-built game reaching the same
 * full-screen mount has no entry here and still gets a title sequence.
 */
export function accentFor(gameId?: string): string {
  return (gameId && ACCENTS[gameId]) || DEFAULT_ACCENT;
}
